<div class="password-requirements">
  <p class="requirements-heading" i18n="@@passwordRequirements.heading">
    Your password must contain:
  </p>

  <ul class="requirements-list">
    <li
      *ngFor="let requirement of requirements; trackBy: trackByRequirement"
      class="requirement"
      [class.met]="requirement.met"
      [attr.data-requirement]="requirement.id"
      [attr.aria-label]="requirement.ariaLabel"
    >
      <i
        class="requirement-icon"
        [ngClass]="
          requirement.met ? 'ri-checkbox-circle-fill' : 'ri-checkbox-circle-line'
        "
        aria-hidden="true"
      ></i>
      <span class="requirement-label">{{ requirement.label }}</span>
    </li>
  </ul>
</div>
